var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgJo = function SvgJo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21796_21023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21796_21023)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#327F44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 6.66667,
    height: 20,
    transform: "rotate(90 20 0)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6.66602,
    width: 6.66667,
    height: 20,
    transform: "rotate(90 20 6.66602)",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10L-0.75 1.33974L-0.75 18.6603L12 10Z",
    fill: "#C82A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8L4.33146 9.31172L5.56366 8.75302L4.74478 9.83001L5.94986 10.445L4.59727 10.4763L4.86777 11.8019L4 10.7639L3.13223 11.8019L3.40273 10.4763L2.05014 10.445L3.25522 9.83001L2.43634 8.75302L3.66854 9.31172L4 8Z",
    fill: "#F6F8FA"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgJo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/jo.42473b4cee9fbeddec7eaa9e8356fc64.svg";